import {BaseModel} from '../../core/base/base-model';

export class GlobalVariables extends BaseModel {
    static readonly HOME_ROUTE = '';
    static readonly MEMBER_ONLY = '/member-feeds';
    static readonly MY_FOLLOWING = '/following';
    static readonly partnerObjects = {
        GLOBAL: {
            id: 1,
            name: 'Global',
            value: '',
            title: '',
            welcome: 'Cameralla Club',
            slogan: 'Explore the community’s photos'
        },
        CANON: {
            id: 2,
            name: 'Canon',
            value: 'canon',
            title: 'Canon Photo Club',
            welcome: 'Welcome to the Canon Photo Club',
            slogan: 'See the beautiful photos our members have taken using their Canon gear.',
            logo: '../../../../../assets/images/logo-canon.png'
        },
        MOBILE: {
            id: 3,
            name: 'Mobile',
            value: 'mobil',
            title: 'Mobile Photo Club',
            welcome: 'Welcome to the Mobile Photo Club',
            slogan: 'See the beautiful photos our members have taken using their mobile devices.',
            logo: ''
        },
        HURTIGRUTEN: {
            id: 4,
            name: 'Hurtigruten',
            value: 'hurtigruten',
            title: 'Hurtigruten Photo Club',
            welcome: 'Welcome to the Hurtigruten Photo Club',
            slogan: 'See the beautiful photos our members have taken.',
            logo: ''
        },
        KAMPSPORT: {
            id: 5,
            name: 'Kampsport',
            value: 'kampsport',
            title: 'Kampsport Photo Academy',
            welcome: 'Welcome to the Kampsport Photo Academy',
            slogan: 'See the beautiful photos our members have taken.',
            logo: ''
        },
        NAF: {
            id: 6,
            name: 'NAF',
            value: 'naf',
            title: 'NAF - Veien til bedre bilder',
            welcome: 'Welcome to the NAF - Veien til bedre bilder',
            slogan: 'See the beautiful photos our members have taken.',
            logo: ''
        },
        VIP: {
            id: 1,
            name: 'Global',
            value: 'vip',
            title: '',
            welcome: 'Cameralla Club',
            slogan: 'Explore the community’s photos'
        },
        FOLLOWING: {
            id: 1,
            name: 'Global',
            value: 'following',
            title: '',
            welcome: 'Cameralla Club',
            slogan: 'Explore the community’s photos'
        },
    };
    
    static readonly additionalClubType = [
        {
            id: 0,
            name: 'My private photos'
        },
        {
            id: 99,
            name: 'Reward location'
        },
    ]
    
    static readonly partnerNavigators = Object.keys(GlobalVariables.partnerObjects).map((k) => GlobalVariables.partnerObjects[k]);

    static readonly sourceObjects = {
        DEFAULT: {
            id: 0,
            name: 'Choose your camera type',
            value: 'default',
            button: 'Upload System camera',
            desc: 'default'
        },
        SYSTEM: {
            id: 1,
            name: 'System',
            value: 'system',
            button: 'Upload System camera',
            desc: 'system camera'
        },
        MOBILE: {
            id: 3,
            name: 'Mobile',
            value: 'mobile',
            button: 'Upload Mobile camera',
            desc: 'mobile phone'
        },
        
    };
    static readonly sourceNavigators = Object.keys(GlobalVariables.sourceObjects).map((k) => GlobalVariables.sourceObjects[k]);

    static readonly tag_collection = [
        {
            id: 1,
            name: 'Fotoskolen',
            value: 'fotoskolen'
        },
        {
            id: 2,
            name: 'Grunnkurs',
            value: 'grunnkurs',
            href: 'https://no.camerallaphoto.com/kurspakker'
        },
        {
            id: 3,
            name: 'Ta kontroll',
            value: 'ta kontroll'
        },
        {
            id: 4,
            name: 'Fotoglede',
            value: 'fotoglede',
            href: 'https://no.camerallaphoto.com/kurspakker'
        },
        {
            id: 5,
            name: 'Canon',
            value: 'canon'
        },
        {
            id: 6,
            name: 'Mobile',
            value: 'mobil',
            href: 'https://no.camerallaphoto.com/kurspakker'
        }
    ];

    static readonly mobile_device_list = [
        'apple',
        'iphone',
        'samsung',
        'galaxy',
        'htc',
        'motorola',
        'huawei',
        'nokia',
        'sony',
        'xiaomi',
        'lg',
    ];

    static CURRENT_PARTNER = GlobalVariables.partnerNavigators[0];
}
